import { getCurrentBrand } from '@/utils/getCurrentBrand';
import { merge } from '@/utils/merge';
import baseGridSystem from 'base/configs/grid.system';

export const getGridSystemConfig = () => {
  const { slug } = getCurrentBrand();
  const brandGridSystem = {};

  try {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    Object.assign(brandGridSystem, require(`${slug}/configs/grid.system`));
  } catch {
    // ignore
  }

  const gridSystem = merge(baseGridSystem, brandGridSystem) as Record<string, any>;

  return gridSystem;
};
